import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeriadoService {
private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  getFeriados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    filterParametro: string | null,
    filterData:any | null,
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')

      if (filterData?.value?.anos) {
        filterData?.value?.anos.forEach((filter: any) => params = params.append('ano', filter));
      }
      // .set('nomeOuNumeroContrato', filterParametro || filterData?.value?.contractNumber || '' )

    return this.http.get(this.baseUrl + `/v1/feriados`, { params });
  }

  getFeriado(id:any) {
    return this.http.get(this.baseUrl + `/v1/feriados/${id}`);
  }
  getTiposFeriado(){
    return this.http.get(this.baseUrl + `/v1/feriados/tipos`);
  }
  create(data:any){
    return this.http.post(this.baseUrl + `/v1/feriados`, data );
  }
  copiarFeriados(data:any){
    return this.http.post(this.baseUrl + `/v1/feriados/copiar`, data );
  }
  edit(data:any, idFeriado: string | null){
    return this.http.put(this.baseUrl + `/v1/feriados/${idFeriado}`, data );
  }
  deleteFeriado(id:any) {
    return this.http.delete(this.baseUrl + `/v1/feriados/${id}`);
  }
  getHistorico(id: string | null, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/feriados/${id}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`
    );
  }

  getAnosDisponiveis(){
    return this.http.get(this.baseUrl + `/v1/feriados/anos`);
  }

getAnosOrigem():any {
  return this.http.get(this.baseUrl + `/v1/feriados/anos`);
}

getAnosDestino(): any {
  return this.http.get(this.baseUrl + `/v1/feriados/anos-destino`);
}

  getProjeto(idProjeto:any){
        return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}`);
  }
  editarDisciplina(idProjeto:any, idDisciplina:any, formData: FormData){
    return this.http.put(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}`, formData )
  }
 
  getDisciplinaPorId(idProjeto: string,idDisciplina: string) {
    return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}`);
  }
  createProjeto(formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/projetos/servicos-ampliacao`, formData);
  }
  createDisciplinaVolume(idProjeto:string, formData: FormData){
    return this.http.post(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas`, formData);
  }

  
  getParametrosServicos(
    idContrato:any
  ) {
    return this.http.get(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-ampliacao/ativos?page=0&size=10&sortDirection=asc&sortField=descricaoServico`);
  }


  getAfericaoOperacional(idRelatorioContratual: string) {
    return this.http.get(this.baseUrl + `/v1/afericoes/relatorios-operacionais/${idRelatorioContratual}`);
  }

  getTiposInvestimentos() {
    return this.http.get(
      this.baseUrl +
      `/v1/tipos-investimento?page=0&size=100&sortDirection=asc&sortField=nome&nome=&descricao=`
    );
  }
  getTiposProjetos() {
    return this.http.get(
      this.baseUrl +
      `/v1/tipos-projeto?page=0&size=100&sortDirection=asc&sortField=id&nome=&descricao=`
    );
  }
  getContratos(){
    return this.http.get(
      this.baseUrl +
      `/v1/contracts/actives?page=0&size=100&sortField=contractNumber&sortDirection=asc`
    );
  }
 getDocumentosAssinados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinados`
      , { params }
    );
  }
  getDocumentosComprovacao(
    idParametroServicoInicial: string,
    idDocumentoComprovacao: string,
  ) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/${idDocumentoComprovacao}`
    );
  }
  getDocumentosPendentes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinaturas-pendentes`
      , { params }
    );
  }
  assinarDocumento(idParametroServicoInicial: any, idUsuarioAssinante: any,) {
    const data = {
      idUsuarioAssinante: idUsuarioAssinante
    }
    return this.http.post(`${this.baseUrl}/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinar`, data)
  }
  desvincularDisciplina(idProjeto: any,idDisciplinaProjeto: any) {
    return this.http.delete(`${this.baseUrl}/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplinaProjeto}`,)
  }
    getDetalhesItemAnalise(idParametroServicoInicial: string, idItemAnalise: string) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/analises/documentos/${idItemAnalise}`
    );
  }
    getAnaliseAfericoes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/analises`
      , { params }
    );
  }
}
